import React, { ReactNode } from 'react'
import Modal from 'react-modal'
import FilterMenuHeader, { Props as HeaderProps } from './FilterMenuHeader'
import { ReactComponent as BackIcon } from 'images/icons/icn_arrow_left.svg'
import styles from './filter-menu-page.module.scss'
import { useTranslation } from 'react-i18next'
import { ClassNamesProps } from 'types/utilities'
import cx from 'classnames'

type ClassKeys = 'modal' | 'header' | 'body'

interface Props extends HeaderProps, ClassNamesProps<ClassKeys> {
  controls: { isOpen: boolean; setIsOpen: (open: boolean) => void }
  children: ReactNode
  withBackBtn?: boolean
  onClose?: () => void
}

const FilterMenuPage = ({
  children,
  title,
  controls,
  btnLeft,
  btnRight,
  withBackBtn,
  classNames,
  onClose,
}: Props) => {
  const { isOpen, setIsOpen } = controls
  const { t } = useTranslation('strMobileFilter')
  const BackBtn = (
    <span className={styles.back}>
      <BackIcon aria-hidden />
      {t('goBack')}
    </span>
  )
  const left = withBackBtn
    ? {
        content: BackBtn,
        onClick: () => {
          setIsOpen(false)
        },
      }
    : btnLeft

  return (
    <Modal
      closeTimeoutMS={500}
      isOpen={isOpen}
      className={cx(styles.modalWrapper, classNames?.modal)}
      onAfterClose={onClose}
    >
      <FilterMenuHeader
        title={title}
        btnLeft={left}
        btnRight={btnRight}
        className={cx(classNames?.header)}
      />
      <section className={cx(styles.body, classNames?.body)}>{children}</section>
    </Modal>
  )
}

export default FilterMenuPage
